export const FLAG_MAX_DENSITY = 0.33;

// A signal true for more than a third of the rows is not a signal, it is a
// column. Above the threshold the per-row badge disappears and the count moves
// into the console's facts line as a filter.
export function flagMode(rows, predicate) {
  const total = (rows || []).length;
  if (!total) return { mode: "row", count: 0, total: 0, ratio: 0 };
  const count = rows.reduce((n, r) => n + (predicate(r) ? 1 : 0), 0);
  const ratio = count / total;
  return { mode: ratio >= FLAG_MAX_DENSITY ? "summary" : "row", count, total, ratio };
}

// A column whose value is missing on a third of the rows does not render; its
// width is paid back to row height.
export function columnMode(rows, hasValue) {
  const { mode, count, total, ratio } = flagMode(rows, (r) => !hasValue(r));
  return { show: mode === "row", missing: count, total, ratio };
}
